import api from "@/lib/api";

const CONSENT = "sq_cookie_consent";
const ATTR = "sq_attr";

// "accepted" = all, "rejected" = none, "custom" = per-category choice in sq_cookie_prefs.
export const consentFor = (cat) => {
  try {
    const v = localStorage.getItem(CONSENT);
    if (v === "accepted") return true;
    if (v !== "custom") return false;
    return !!JSON.parse(localStorage.getItem("sq_cookie_prefs") || "{}")[cat];
  } catch { return false; }
};
export const hasConsent = () => consentFor("analytics");

function device() {
  const w = window.innerWidth;
  return w < 768 ? "mobile" : w < 1024 ? "tablet" : "desktop";
}

export function captureAttribution() {
  try {
    if (sessionStorage.getItem(ATTR)) return;
    const p = new URLSearchParams(window.location.search);
    const a = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      const v = p.get(k);
      if (v) a[k] = v.slice(0, 100);
    });
    const r = document.referrer;
    if (r && !r.includes(window.location.host)) a.referrer = r.slice(0, 200);
    a.landing_page = window.location.pathname;
    a.device = device();
    sessionStorage.setItem(ATTR, JSON.stringify(a));
  } catch {}
}

export const getAttribution = () => {
  try { return JSON.parse(sessionStorage.getItem(ATTR) || "{}"); } catch { return {}; }
};

function anonId() {
  let id = localStorage.getItem("sq_aid");
  if (!id) {
    id = (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) || String(Math.random()).slice(2);
    localStorage.setItem("sq_aid", id);
  }
  return id;
}

export function clearAnalyticsId() {
  try { localStorage.removeItem("sq_aid"); } catch {}
}

// Founder funnel: first-party event + Meta Pixel custom event (only if a Pixel is already installed), deduplicated by event_id.
export function trackFunnel(name, props = {}, eventId) {
  const id = eventId || `${name}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  trackEvent(name, { ...props, event_id: id });
  try {
    if (consentFor("ads") && typeof window.fbq === "function") {
      window.fbq("trackCustom", name, props, { eventID: id });
      if (name === "founder_demo_booking_confirmed") window.fbq("track", "Schedule", { content_name: "Demo gratuita Founder 100" }, { eventID: id });
    }
  } catch {}
  return id;
}

// First-party product analytics: sent only after analytics cookie consent.
export function trackEvent(name, props = {}) {
  if (!hasConsent()) return;
  try {
    api.post("/track", { name, anon_id: anonId(), props: { ...getAttribution(), path: window.location.pathname, ...props } }).catch(() => {});
  } catch {}
}
